import RightPanelCard from 'components/CommonComponents/RightPanelCard'
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardFooter, CardHeader, Input, Label } from 'reactstrap';
import CommonTable from 'components/CommonComponents/ReactTable/Table';
import { DEFAULT_RECORDS_PER_PAGE, ALL_SESSION_TYPE_OPTIONS, SESSION_STATUS_OPTIONS } from 'components/constant';
import { useSelector } from 'react-redux';
import { getAdminsSessionsWiseAttendanceList } from 'action/attendanceModule';
import { formatTime24Hour } from 'components/CommonComponents/CommonFunctions';

const initialFormData = {
    batchId: {
        value: "",
        error: "",
        isChanged: false,
    },
    sessionDate: {
        value: "",
        error: "",
        isChanged: false,
    },
    sessionStartTime: {
        value: "",
        error: "",
        isChanged: false,
    },
    sessionEndTime: {
        value: "",
        error: "",
        isChanged: false,
    },
    sessionType: {
        value: { value: "OFFLINE", label: "Offline" },
        error: "",
        isChanged: false,
    },
    sessionStatus: {
        value: "",
        error: "",
        isChanged: false,
    },
};

function ManageOfflineAttendance(props) {
    const courseEnrollmentData = useSelector(
        (state) => state.batch.courseEnrollmentList,
    );
    const [formData, setFormData] = useState(initialFormData);
    const [alternative, setAlternative] = useState({
        isLoading: true,
        showLoaderOnClick: false,
        showLoaderOnSearch: false,
        error: "",
        noRecords: false,
    });

    const [selectedRows, setSelectedRows] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [searchState, setSearchState] = useState({
        searchName: "",
        searchEmail: "",
        searchMobile: "",
        filterParams: [],
    });
    const [trainees, setTrainees] = useState([]);
    const [attendanceMap, setAttendanceMap] = useState({});
    const [traineesRecords, setTraineesRecords] = useState({ totalRecords: null, totalFilteredRecords: null });

    const filterKey = JSON.stringify(searchState.filterParams || []);

    useEffect(() => {
        if (!props.openAttendaceModel) return
        if (props?.mode === "View") {
            setAlternative((prev) => ({ ...prev, isLoading: true, }));
            getSessionData();
        }
    }, [props.openAttendaceModel, pageNum, filterKey]);

    const getSessionData = async () => {
        const res = await getAdminsSessionsWiseAttendanceList(props?.session?.id, pageNum, searchState.filterParams?.length ? searchState.filterParams : []);
        if (res?.code === 200) {
            const traineeList = (res?.data?.trainees || []).map(
                (trainee) => ({
                    id: trainee.traineeId,
                    traineeName: trainee.fullName || trainee.traineeName || "-",
                    email: trainee.email || trainee.traineeEmail || "-",
                    attendance: trainee.attendanceStatus === "ABSENT"
                        ? "Absent"
                        : "Present"
                })
            );

            const initialAttendanceMap = (res?.data?.trainees || []).reduce(
                (acc, trainee) => {
                    acc[trainee.traineeId] =
                        trainee.attendanceStatus === "ABSENT"
                            ? "Absent"
                            : "Present";

                    return acc;
                },
                {}
            );

            setTraineesRecords({ totalRecords: res?.data?.totalRecords, totalFilteredRecords: res?.data?.totalFilteredRecords })

            setAttendanceMap(initialAttendanceMap);

            setTrainees(traineeList);

            setFormData((prev) => ({
                ...prev,
                batchId: {
                    ...prev.batchId,
                    value: props.batch.id,
                },
                sessionDate: {
                    ...prev.sessionDate,
                    value: res?.data?.sessionDate
                        ? new Date(res.data.sessionDate)
                        : null,
                },
                sessionStartTime: {
                    ...prev.sessionStartTime,
                    value:
                        props?.mode === "Edit"
                            ? formatTime24Hour(res?.data?.sessionStartTime)
                            : res?.data?.sessionStartTime,
                },
                sessionEndTime: {
                    ...prev.sessionEndTime,
                    value:
                        props?.mode === "Edit"
                            ? formatTime24Hour(res?.data?.sessionEndTime)
                            : res?.data?.sessionEndTime,
                },
                sessionType: {
                    ...prev.sessionType,
                    value:
                        ALL_SESSION_TYPE_OPTIONS.find(
                            item => item.value === res.data.sessionType
                        ) || null,
                },
                sessionStatus: {
                    ...prev.sessionStatus,
                    value:
                        SESSION_STATUS_OPTIONS.find(
                            item => item.value === res.data.sessionStatus
                        ) || null,
                },
            }));

            setAlternative({
                isLoading: false,
                error: "",
                noRecords: res?.data?.trainees?.length === 0,
                showLoaderOnClick: false,
                showLoaderOnSearch: false,
            });
        } else if (res?.code || res?.message) {
            setTrainees([]);

            setAlternative({
                isLoading: false,
                error:
                    res?.message ||
                    "Failed to load enrolled students! Please try again.",
                noRecords: false,
                showLoaderOnClick: false,
                showLoaderOnSearch: false,
            });
        }
    };

    const traineeTableData = trainees.map((trainee, index) => ({
        ...trainee,
        srNo:
            ((pageNum - 1) *
                (courseEnrollmentData?.data?.noOfRecordsPerPage ||
                    DEFAULT_RECORDS_PER_PAGE)) +
            index +
            1,
    }));

    const allSelected =
        traineeTableData?.length > 0 &&
        traineeTableData?.every((t) => selectedRows.includes(t.id));

    // const addMinutes = (time, minutes) => {
    //     if (!time) return "";

    //     const [hour, minute] = time.split(":").map(Number);

    //     const date = new Date();
    //     date.setHours(hour, minute + minutes, 0, 0);

    //     return date.toTimeString().slice(0, 5);
    // };

    const toggleRowSelection = (id) => {
        setSelectedRows((prev) =>
            prev.includes(id)
                ? prev.filter((rowId) => rowId !== id)
                : [...prev, id]
        );

    };

    const toggleSelectAll = () => {
        if (allSelected) {
            setSelectedRows((prev) =>
                prev.filter(
                    (id) => !traineeTableData?.some((t) => t.id === id)
                )
            );
        } else {
            const ids = traineeTableData?.map((t) => t.id);

            setSelectedRows((prev) => [
                ...new Set([...prev, ...ids]),
            ]);
        }
    };

    const columns =
        props.mode === "View"
            ? [
                {
                    Header: "Sr. No.",
                    accessor: "srNo",
                    centerAlign: true,
                    minWidth: 100,
                    maxWidth: 160,
                },
                {
                    Header: "Name",
                    accessor: "traineeName",
                    minWidth: 250,
                    Cell: ({ value }) => (
                        <span className="text-wrapper">{value || "-"}</span>
                    ),
                },
                {
                    Header: "Email",
                    accessor: "email",
                    minWidth: 180,
                    Cell: ({ value }) => (
                        <span className="text-wrapper">{value || "-"}</span>
                    ),
                },
                {
                    Header: "Attendance",
                    accessor: "attendance",
                    minWidth: 120,
                    centerAlign: true,
                    Cell: ({ value }) => (
                        <span
                            className={`attendance-badge ${value === "Present"
                                ? "present"
                                : "absent"
                                }`}
                        >
                            <i
                                className={`fa ${value === "Present"
                                    ? "fa-check-circle"
                                    : "fa-times-circle"
                                    }`}
                            />
                            {value}
                        </span>
                    ),
                },
            ] : [
                {
                    Header: (
                        <Input
                            type="checkbox"
                            checked={allSelected}
                            onChange={toggleSelectAll}
                            className="attendance-checkbox"
                        />
                    ),
                    accessor: "select",
                    disableSortBy: true,
                    minWidth: 10,
                    maxWidth: 10,
                    Cell: ({ row }) => (
                        <Input
                            type="checkbox"
                            checked={selectedRows.includes(row.original.id)}
                            onChange={() => toggleRowSelection(row.original.id)}
                            className="attendance-checkbox"
                        />
                    ),
                },
                {
                    Header: "Sr. No.",
                    accessor: "srNo",
                    centerAlign: true,
                    minWidth: 20,
                    maxWidth: 50,
                },
                {
                    Header: "Name",
                    accessor: "traineeName",
                    minWidth: 160,
                    maxWidth: 250,
                    Cell: ({ value }) => <span className="text-wrapper">{value || "-"}</span>,
                },
                {
                    Header: "Email",
                    accessor: "email",
                    minWidth: 200,
                    maxWidth: 250,
                    Cell: ({ value }) => <span className="text-wrapper">{value || "-"}</span>,
                },
                {
                    Header: "Mark Attendance",
                    disableSortBy: true,
                    Cell: ({ row }) => {
                        const { id, attendance } = row.original;

                        const isPresent = attendance === "Present";
                        const isAbsent = attendance === "Absent";

                        return (
                            <div className="attendance-toggle">
                                <button
                                    className={isPresent ? "active present" : ""}
                                    onClick={() => updateTraineeAttendance(id, "Present")}
                                >
                                    <i className="fa fa-check" />
                                    Present
                                </button>

                                <button
                                    className={isAbsent ? "active absent" : ""}
                                    onClick={() => updateTraineeAttendance(id, "Absent")}
                                >
                                    <i className="fa fa-times" />
                                    Absent
                                </button>
                            </div>
                        );
                    },
                },
            ];

    // const handleInputChange = (field, value) => {
    //     setFormData((prev) => {
    //         const updated = {
    //             ...prev,
    //             [field]: {
    //                 ...prev[field],
    //                 value,
    //                 error: "",
    //                 isChanged: true,
    //             },
    //         };

    //         if (props?.mode === "Add" && field === "sessionStartTime") {
    //             const minimumEndTime = addMinutes(value, 30);
    //             if (
    //                 !prev.sessionEndTime.value ||
    //                 prev.sessionEndTime.value < minimumEndTime
    //             ) {
    //                 updated.sessionEndTime = {
    //                     ...prev.sessionEndTime,
    //                     value: minimumEndTime,
    //                     error: "",
    //                     isChanged: true,
    //                 };
    //             }
    //         }

    //         return updated;
    //     });
    // };

    const buildFilterParams = () => {
        const filterParams = [];

        if (searchState.searchName?.trim()) {
            filterParams.push({
                field: "TraineeName",
                condition: "like",
                filterValues: [searchState.searchName.trim()],
            });
        }

        if (searchState.searchEmail?.trim()) {
            filterParams.push({
                field: "Email",
                condition: "like",
                filterValues: [searchState.searchEmail.trim()],
            });
        }

        return filterParams?.length > 0 ? JSON.stringify(filterParams) : [];
    };

    const handleSearch = () => {
        const newFilterParams = buildFilterParams();

        if (
            JSON.stringify(searchState.filterParams) !==
            JSON.stringify(newFilterParams)
        ) {
            setAlternative((prev) => ({
                ...prev,
                isLoading: true,
                showLoaderOnSearch: true,
            }));

            setSearchState((prev) => ({
                ...prev,
                filterParams: newFilterParams,
            }));

            if (pageNum !== 1) {
                setPageNum(1);
            }
        }
    };

    const handleClear = () => {
        setAlternative((prev) => ({
            ...prev,
            isLoading: false,
            showLoaderOnSearch: false,

        }));

        setSearchState({
            searchName: "",
            searchEmail: "",
            searchMobile: "",
            filterParams: [],
        });

        if (pageNum !== 1) {
            setPageNum(1);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearch();
        }
    };

    const markSelectedPresent = () => {
        setAttendanceMap(prev => {
            const updated = { ...prev };

            selectedRows.forEach(id => {
                updated[id] = "Present";
            });

            return updated;
        });

        setTrainees(prev =>
            prev.map(t =>
                selectedRows.includes(t.id)
                    ? { ...t, attendance: "Present" }
                    : t
            )
        );

        setSelectedRows([]);
    };

    const markSelectedAbsent = () => {
        setAttendanceMap(prev => {
            const updated = { ...prev };

            selectedRows.forEach(id => {
                updated[id] = "Absent";
            });

            return updated;
        });

        setTrainees(prev =>
            prev.map(t =>
                selectedRows.includes(t.id)
                    ? { ...t, attendance: "Absent" }
                    : t
            )
        );

        setSelectedRows([]);
    };

    const updateTraineeAttendance = (id, status) => {
        setAttendanceMap(prev => ({
            ...prev,
            [id]: status,
        }));

        setTrainees(prev =>
            prev.map(t =>
                t.id === id
                    ? { ...t, attendance: status }
                    : t
            )
        );
    };

    const handleClose = () => {
        setFormData(initialFormData);
        setSearchState({
            searchName: "",
            searchEmail: "",
            searchMobile: "",
            filterParams: [],
        });
        setSelectedRows([]);
        setPageNum(1);
        setAttendanceMap({});
        setTrainees([]);
        setAlternative({
            isLoading: true,
            showLoaderOnClick: false,
            showLoaderOnSearch: false,
            error: "",
            noRecords: false,
        });
        setTraineesRecords({ totalRecords: null, totalFilteredRecords: null });
        props.handleCloseModel()
    }


    return (
        <RightPanelCard
            isOpen={props.openAttendaceModel}
            onClose={handleClose}
            fullHeight
            enableScroll={true}
        >
            <Card className="attendance-card shadow-none border-0">
                <CardHeader>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <h4 className="mb-0 text-default">{props?.mode === "View"
                                ? "Attendance Details"
                                : `${props?.mode} Attendance`}</h4>
                        </div>

                        <i
                            className="fa-solid fa-xmark cursor text-muted"
                            onClick={() => handleClose()}
                        />
                    </div>
                </CardHeader>
                <CardBody className="attendance-card-body">
                    {/* <div className="context-description">
                        <i className="fa fa-info-circle mr-2" />
                        Add a session and mark trainee attendance for the selected lesson.
                    </div>

                    <div className="session-context">
                        <div className="context-item">
                            <span className="context-label">Lesson</span>
                            <h4>{props.panelData?.lesson?.name}</h4>
                        </div>
                    </div>
                    <hr className="divider" /> */}

                    <h4 className={`mb-0 text-default mb-3`}>Session Details</h4>
                    <div className="session-summary">
                        <div className="summary-item">
                            <Label className="small-label text-muted mb-0">Session Date</Label>
                            <p className="small-text text-wrapper">{formData.sessionDate.value
                                ? format(formData.sessionDate.value, "dd MMM yyyy")
                                : "-"}
                            </p>
                        </div>

                        <div className="summary-item">
                            <Label className="small-label text-muted mb-0">Session Time</Label>
                            <p className="small-text text-wrapper">
                                {formData.sessionStartTime.value} - {formData.sessionEndTime.value}
                            </p>
                        </div>

                        <div className="summary-item">
                            <Label className="small-label text-muted mb-0">Session Type</Label>
                            <p className="small-text text-wrapper">{formData.sessionType.value?.label}</p>
                        </div>

                        {/*<div className="summary-item">
                                    <Label className="small-label text-muted mb-0">Status</Label>
                                    <p className="small-text text-wrapper">{formData.sessionStatus.value?.label}</p>
                                </div>*/}
                    </div>

                    <div className="divider mt-2 mb-4" />
                    <h4 className={`mb-0 text-default mb-4`}>Trainee List</h4>
                    <div className="d-flex align-items-center justify-content-between flex-wrap flex-column flex-md-row mt-3 mb-0">
                        <div className="d-flex flex-wrap align-items-center filter-group">
                            <Input
                                type="text"
                                placeholder="Search by name"
                                className="mr-2 mb-2 filter-input-large"
                                value={searchState.searchName}
                                onChange={(e) =>
                                    setSearchState((prev) => ({
                                        ...prev,
                                        searchName: e.target.value,
                                    }))
                                }
                                onKeyDown={handleKeyDown}
                            />
                            <Input
                                type="text"
                                placeholder="Search by email"
                                className="mr-2 mb-2 filter-input-large"
                                value={searchState.searchEmail}
                                onChange={(e) =>
                                    setSearchState((prev) => ({
                                        ...prev,
                                        searchEmail: e.target.value,
                                    }))
                                }
                                onKeyDown={handleKeyDown}
                            />
                            <Button
                                color="default"
                                className={`d-flex align-items-center mb-2 filter-btn btn-deep-blue ${alternative.showLoaderOnSearch ? "search-btn" : ""}`}
                                onClick={handleSearch}
                            >
                                {alternative.showLoaderOnSearch ? (
                                    <i className="fa fa-spinner fa-spin loader" />
                                ) : (
                                    <>
                                        <i className="fa fa-search mr-1" />
                                        Search
                                    </>
                                )}
                            </Button>

                            {searchState?.filterParams?.length > 0 && (
                                <Button
                                    color="default"
                                    className="d-flex align-items-start mb-2 ml-0 filter-btn btn-deep-blue px-4"
                                    onClick={handleClear}
                                >
                                    <i className="fa fa-times mr-1 mt-1" /> Clear
                                </Button>
                            )}
                        </div>
                    </div>
                    {props.mode !== "View" &&
                        <>
                            <div className="attendance-toolbar">
                                <div>
                                    <span className="selected-count">
                                        Selected trainees: {selectedRows?.length}
                                    </span>
                                </div>

                                <div className="attendance-actions">
                                    <Button
                                        color={!selectedRows?.length ? "secondary" : "success"}
                                        outline={selectedRows?.length ? true : false}
                                        className="mr-2 save-btn-lg"
                                        type="button"
                                        onClick={markSelectedPresent}
                                    >
                                        <i className="fa fa-check mr-2" />
                                        Mark Present
                                    </Button>

                                    <Button
                                        color={!selectedRows?.length ? "secondary" : "warning"}
                                        outline={selectedRows?.length ? true : false}
                                        className="mr-2 save-btn-lg"
                                        type="button"
                                        onClick={markSelectedAbsent}
                                    >
                                        <i className="fa fa-times mr-2" />
                                        Mark Absent
                                    </Button>
                                </div>
                            </div>
                        </>
                    }

                    {alternative.isLoading ? (<div className="attendanceContainer">
                        <i className="fa fa-spinner fa-spin fa-2xl loader" />
                    </div>) : alternative.error ? (
                        <div className="attendanceContainer error-style">
                            <div className="error-icon">
                                <i className="fa-solid fa-circle-exclamation" />
                            </div>
                            <span>{alternative.error}</span>
                        </div>
                    ) : alternative.noRecords ? (
                        <div className="attendanceContainer empty-style">
                            <div className="empty-icon">
                                <i className="fa-solid fa-circle-info" />
                            </div>
                            <span>No enrolled trainee found.</span>
                        </div>
                    ) : <div className="table-responsive">
                        <CommonTable
                            columns={columns}
                            data={traineeTableData}
                            defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
                            activePage={pageNum}
                            setPageNum={setPageNum}
                            // totalPages={Math.ceil(
                            //     (courseEnrollmentData?.data?.totalFilteredRecords || traineeTableData?.length) /
                            //     (courseEnrollmentData?.data?.noOfRecordsPerPage || DEFAULT_RECORDS_PER_PAGE),
                            // )}

                            totalPages={
                                props.mode === "Add"
                                    ? Math.ceil(
                                        (courseEnrollmentData?.data?.totalFilteredRecords || 0) /
                                        (courseEnrollmentData?.data?.noOfRecordsPerPage ||
                                            DEFAULT_RECORDS_PER_PAGE)
                                    )
                                    : Math.ceil(
                                        traineesRecords?.totalRecords / DEFAULT_RECORDS_PER_PAGE
                                    )
                            }

                            showPaginationBottom={true}
                        />
                    </div>}
                </CardBody>
                <CardFooter className="attendance-footer">
                    <Button
                        color="secondary"
                        className="mr-2 save-btn-sm"
                        type="button"
                        onClick={handleClose}
                        disabled={alternative.showLoaderOnClick}
                    >
                        Close
                    </Button>
                </CardFooter>
            </Card>

        </RightPanelCard>
    )
}

export default ManageOfflineAttendance
